"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardSalesOrderRelease = void 0;
const product_dashboard_location_response_1 = require("./product-dashboard-location.response");
const product_dashboard_metadata_response_1 = require("./product-dashboard-metadata.response");
class ProductDashboardSalesOrderRelease {
}
exports.ProductDashboardSalesOrderRelease = ProductDashboardSalesOrderRelease;
//# sourceMappingURL=product-dashboard-sales-order-release.response.js.map